export default __webpack_public_path__ + "static/media/Mystic Atlantean Relic.1e79790f.jpg";